import { render } from "./ClipboardButton.vue?vue&type=template&id=616b5634"
import script from "./ClipboardButton.vue?vue&type=script&lang=js"
export * from "./ClipboardButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__